const totalPeopleConfig = (dataArray) => {

  const sharedOptions = {
    maintainAspectRatio: false,
    responsive: true,
    legend: {
      display: false
    }
  };
  
  const dataPie = {
    labels: ['Sector público', 'Sector privado', 'Comunidades'],
    datasets: [{
      data: dataArray,
      backgroundColor: ['#A489D4','#4EC2F7', '#B7E29E'],
      hoverBackgroundColor: ["rgba(126,87,194,1)", "rgba(3,169,244,1)",  "rgba(151,213,118,1)"],
      borderWidth: 5,
      hoverBorderColor: ['#fff', '#fff', '#fff'],
    }]
  };
  
  
  return {
    type: 'doughnut',
    title: 'Evacuados por sector',
    subtitle: 'Total de personas evacuadas por sector',
    data: dataPie,
    options: {
      ...sharedOptions,
      elements: {
        arc: {
          borderWidth: 5,
          borderColor: "#fff"
        }
      },
      plugins: {
        // Change options for ALL labels of THIS CHART
        datalabels: {
          display: false
        },
      },
    }
  }

}

export default totalPeopleConfig;